import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-172f9e97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game__page" }
const _hoisted_2 = {
  key: 1,
  style: {"font-size":"20px","color":"#fff"}
}
const _hoisted_3 = { class: "game__page-inner" }
const _hoisted_4 = { class: "game__board" }
const _hoisted_5 = ["data-key"]
const _hoisted_6 = ["data-key"]
const _hoisted_7 = { class: "game__result" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game_result-subheader" }, "Соберите:", -1))
const _hoisted_10 = { class: "game_result-items" }
const _hoisted_11 = { class: "game_result-items-row" }
const _hoisted_12 = { class: "game_result-items-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_block = _resolveComponent("tp-block")!
  const _component_tp_tile = _resolveComponent("tp-tile")!
  const _component_tile_modal = _resolveComponent("tile-modal")!
  const _component_selectel = _resolveComponent("selectel")!
  const _component_tp_box = _resolveComponent("tp-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (1 > 2)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.debugValue) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.debug()))
        }, null, 544)), [
          [_vModelText, _ctx.debugValue]
        ])
      : _createCommentVNode("", true),
    (1 > 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "zero cells: " + _toDisplayString(_ctx.zeroCells) + ", hasStep: " + _toDisplayString(_ctx.hasStep), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_tp_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                "data-key": index,
                class: "game__board-row"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                  return (_openBlock(), _createBlock(_component_tp_block, {
                    number: cell.value,
                    info: cell,
                    key: _ctx.getCellKey(cell.x, cell.y)
                  }, null, 8, ["number", "info"]))
                }), 128))
              ], 8, _hoisted_5))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                "data-key": index,
                class: "game__board-tile-row"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (tile) => {
                  return (_openBlock(), _createBlock(_component_tp_tile, {
                    x: tile.x,
                    y: tile.y,
                    oldX: tile.oldX,
                    oldY: tile.oldY,
                    value: tile.value,
                    merged: tile.merged,
                    new: tile.new,
                    type: _ctx.levelType,
                    key: _ctx.getCellKey(tile.x, tile.y),
                    isAbsolute: true
                  }, null, 8, ["x", "y", "oldX", "oldY", "value", "merged", "new", "type"]))
                }), 128))
              ], 8, _hoisted_6))
            }), 128)),
            _createVNode(_component_tile_modal, {
              done: _ctx.doneLevel,
              value: _ctx.levelValue,
              type: _ctx.levelType
            }, null, 8, ["done", "value", "type"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "game__result-header",
              innerHTML: _ctx.mainTarget.html
            }, null, 8, _hoisted_8),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_tp_tile, {
                  class: "game_result-item-tile",
                  isAbsolute: false,
                  value: _ctx.items[0].needValue,
                  type: _ctx.items[0].type,
                  done: _ctx.items[0].done,
                  isHard: _ctx.isHard,
                  isActive: _ctx.isActiveTile(_ctx.items[0].type)
                }, null, 8, ["value", "type", "done", "isHard", "isActive"]),
                _createVNode(_component_tp_tile, {
                  class: "game_result-item-tile",
                  isAbsolute: false,
                  value: _ctx.items[1].needValue,
                  type: _ctx.items[1].type,
                  done: _ctx.items[1].done,
                  isHard: _ctx.isHard,
                  isActive: _ctx.isActiveTile(_ctx.items[1].type)
                }, null, 8, ["value", "type", "done", "isHard", "isActive"]),
                _createVNode(_component_tp_tile, {
                  class: "game_result-item-tile game_result-item-tile-mobile",
                  isAbsolute: false,
                  value: _ctx.items[2].needValue,
                  type: _ctx.items[2].type,
                  done: _ctx.items[2].done,
                  isHard: _ctx.isHard,
                  isActive: _ctx.isActiveTile(_ctx.items[2].type)
                }, null, 8, ["value", "type", "done", "isHard", "isActive"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_tp_tile, {
                  class: "game_result-item-tile game_result-item-tile-desktop",
                  isAbsolute: false,
                  value: _ctx.items[2].needValue,
                  type: _ctx.items[2].type,
                  done: _ctx.items[2].done,
                  isHard: _ctx.isHard,
                  isActive: _ctx.isActiveTile(_ctx.items[2].type)
                }, null, 8, ["value", "type", "done", "isHard", "isActive"])
              ])
            ]),
            _createVNode(_component_selectel, { class: "game__page-selectel-logo" })
          ])
        ]),
        _createElementVNode("div", {
          class: "game__blur",
          style: _normalizeStyle(`background: url(${require('@/assets/blue-blur.svg')}) no-repeat center`)
        }, null, 4)
      ]),
      _: 1
    })
  ]))
}